<div class="main">
    <div class="left">
      <div class="inst"><h1>Move the plants around to reveal a code. <br> You have reached the greenhouse</h1></div>
      <model-viewer  camera-controls src="./assets/images/plant/indoor_plant/scene.gltf" auto-rotate>
      </model-viewer>
      <div class="code">Anxiety:
        People with anxiety disorders respond to certain objects or situations with fear and dread, as well as with physical signs of anxiety or panic, such as a rapid heartbeat and sweating.</div>
      <model-viewer style="margin-left:13%"camera-controls src="../../assets/images/plant/ThePlant/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:20%" camera-controls src="../../assets/images/plant/lupine_plant/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:25%"camera-controls src="../../assets/images/plant/steam_punk_plant/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:30%"camera-controls src="./assets/images/plant/prayer_plant/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:35%"camera-controls src="../../assets/images/plant/indoor_pot_plant_3/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:42%"camera-controls src="../../assets/images/plant/plants_succulents/scene.gltf" >
      </model-viewer>
      <model-viewer style="margin-left:48%"camera-controls src="../../assets/images/plant/indoor_pot_plant_3/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:53%"camera-controls src="./assets/images/plant/prayer_plant/scene.gltf" auto-rotate>
      </model-viewer>
      
      <model-viewer style="margin-left:61%"camera-controls src="../../assets/images/plant/steam_punk_plant/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer style="margin-left:67%" camera-controls src="../../assets/images/plant/lupine_plant/scene.gltf" auto-rotate>
      </model-viewer>
          <model-viewer style="margin-left:73%"camera-controls src="../../assets/images/plant/ThePlant/scene.gltf" auto-rotate>
      </model-viewer>
      <model-viewer  style="margin-left:85%" camera-controls src="../../assets/images/plant/indoor_plant/scene.gltf" auto-rotate>
      </model-viewer>
<<<<<<< HEAD
=======
      <model-viewer  style="margin-left:85%" camera-controls src="./assets/images/plant/indoor_plant/scene.gltf" auto-rotate>
      </model-viewer>
>>>>>>> f37046b96c8240fe498c5361590365154a6ac3cb
      
    </div>
  </div>